import React, { useEffect, useState, useCallback } from 'react';
import { Navigation, Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperClass } from 'swiper/types';

import useBreakpoint from '@/components/v2/utils/useBreakPoint';

export interface FindmineCarouselProps {
    data: {
        looks: [{ items: any[]; look_id: '' }];
        response_uuid: '';
    };
    beacon: (action: string, set: number, item: number, activeSlide: number) => any;
}

export const FindmineCarousel = ({ data, beacon }: FindmineCarouselProps) => {
    const { isMobile, isTablet, isDesktop } = useBreakpoint();

    const [swiperRef, setSwiperRef] = useState<SwiperClass>();

    const handlePrevious = useCallback(() => {
        swiperRef?.slidePrev();
    }, [swiperRef]);

    const handleNext = useCallback(() => {
        swiperRef?.slideNext();
    }, [swiperRef]);

    const getWrapperClass = (itemLength) => {
        let finalClass = 'findmine__wrap ';
        if (isMobile) {
            finalClass += 'justifyNormal';
        } else if (isTablet) {
            if (itemLength == 5) {
                finalClass += 'justifyNormal';
            } else {
                finalClass += 'justifyNormal';
            }
        } else if (isDesktop) {
            if (itemLength == 4) {
                finalClass += 'justifyBetween';
            } else if (itemLength == 5) {
                finalClass += 'justifyNormal';
            } else {
                finalClass += 'justifyEven';
            }
        } else {
            if (itemLength == 4) {
                finalClass += 'justifyBetween';
            } else if (itemLength == 5) {
                finalClass += 'justifyEven';
            } else {
                finalClass += 'justifyEven';
            }
        }
        return finalClass;
    };

    const handleClick = (event, url, set, item) => {
        event.preventDefault();
        beacon('item_click', set, item, swiperRef.realIndex);
        setTimeout(() => {
            window.location.href = url;
        }, 150);
    };

    if (!data || !data?.looks || data?.looks?.length < 1) {
        return <>no results</>;
    }

    return (
        <>
            {data && data?.looks && data?.looks?.length > 0 && (
                <>
                    <div className="findmine__header-wrap">
                        {data?.looks?.length > 1 && (
                            <button
                                className="swiper-button-prev findmine__arrow findmine__arrow--prev"
                                type="button"
                                onClick={handlePrevious}
                                data-component-type="get_the_look"
                                data-link-type="link"
                                data-link-title="previous"
                                data-link-position="widget"
                            >
                                <span className="visually-hidden">Previous</span>
                            </button>
                        )}

                        <h2 className="findmine__header ">Get The Look</h2>

                        {data?.looks?.length > 1 && (
                            <>
                                <button
                                    className="swiper-button-next findmine__arrow findmine__arrow--next"
                                    type="button"
                                    onClick={handleNext}
                                    data-component-type="get_the_look"
                                    data-link-type="link"
                                    data-link-title="next"
                                    data-link-position="widget"
                                >
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </>
                        )}
                    </div>

                    <Swiper
                        modules={[Pagination, Navigation, A11y]}
                        className="findmine__slider"
                        slidesPerView={1}
                        pagination={false}
                        loop={true}
                        spaceBetween={0}
                        autoHeight={true}
                        onSwiper={setSwiperRef}
                        runCallbacksOnInit={false}
                        onSlidePrevTransitionStart={(swiper) => {
                            beacon('previous_click', null, null, swiperRef.activeIndex);
                        }}
                        onSlideNextTransitionStart={(swiper) => {
                            beacon(
                                'next_click',
                                null,
                                null,
                                (((swiperRef.realIndex + 1 - 2) % data?.looks?.length) + data?.looks?.length) %
                                    data?.looks?.length,
                            );
                        }}
                        watchOverflow={true}
                        autoplay={false}
                    >
                        {data &&
                            data?.looks &&
                            data?.looks?.length > 0 &&
                            data?.looks?.map((look, i) => (
                                <SwiperSlide
                                    key={look.look_id}
                                    className={getWrapperClass(look.items.length) + ' ' + look.look_id}
                                >
                                    {look.items.map((item, j) => (
                                        <div className={`findmine__item ${item.item_id}`} key={item.item_id}>
                                            <a
                                                onClick={(event) => {
                                                    handleClick(
                                                        event,
                                                        item.item_url + '&stylecode=' + item.details.color_id,
                                                        i,
                                                        j,
                                                    );
                                                }}
                                                href={item.item_url + '&stylecode=' + item.details.color_id}
                                                className="prec-product-link"
                                                data-component-type="get_the_look"
                                                data-link-type="link"
                                                data-link-title={item.details.ItemNo + ':' + item.title}
                                                data-link-position="widget"
                                            >
                                                <div className="prec-parent-container">
                                                    <div className="imgEmbedContainer ratio95-2">
                                                        <div className="prec-img">
                                                            <img
                                                                src={item.image_url}
                                                                loading="lazy"
                                                                alt={item.details.ItemNo + ':' + item.title}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="findine__name">{item.title}</div>
                                                <div className="findmine__brand">
                                                    {item.details.Brand && <>By: {item.details.Brand}</>}
                                                    {!item.details.Brand && <></>}
                                                </div>
                                                <div className="findmine__price">
                                                    <div className="findmine__now-price">
                                                        {item.details.IsPriceRange}
                                                    </div>

                                                    {item.details.IsPriceRange !== item.details.WasPriceRange && (
                                                        <del className="findmine__was-price">
                                                            {item.details.WasPriceRange}
                                                        </del>
                                                    )}
                                                </div>
                                            </a>
                                        </div>
                                    ))}
                                </SwiperSlide>
                            ))}
                    </Swiper>
                </>
            )}
        </>
    );
};
